import { USER_REQUEST, USER_ERROR, USER_SUCCESS, USER_COLDWARM, CHANGE_LANGUAGE, DETECT_LANGUAGE } from '../actions/user'
import apiCall from '../../utils/api'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { status: '', profile: {}, settings: { cold_warm: { value: 0 }, language: null } }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  hasPermission: (state) => (hasPermission) => state.profile.permissions ? state.profile.permissions.find((permission) => { return permission === hasPermission }) : null,
  getLanguage: state => state.settings.language
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      apiCall({url: '/api/user', method: 'GET'})
        .then(resp => {
          commit(USER_SUCCESS, resp)
          resolve()
        })
        .catch(resp => {
          reject(resp)
          commit(USER_ERROR)
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT)
        })
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  },
  [USER_COLDWARM]: (state, resp) => {
    state.settings.cold_warm.value = resp
  },
  [CHANGE_LANGUAGE]: (state, resp) => {
    state.settings.language = resp
  },
  [DETECT_LANGUAGE]: (state) => {
    if (!state.settings.language) {
      if ((window.navigator.userLanguage || window.navigator.language) === 'it') {
        state.settings.language = 'it'
      } else {
        state.settings.language = 'de'
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js